import React from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import SetupChecklist from "../components/SetupChecklist";
import { useAuth } from "../lib/auth";

export default function DashboardLayout() {
  const { user, hydrated } = useAuth();
  const location = useLocation();

  if (!hydrated) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center text-slate-500">
        Loading…
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Paid users who haven't completed the post-subscription onboarding wizard
  // are bounced to /onboarding before they can use the dashboard.
  if (user.plan && user.plan !== "free" && !user.onboarding_completed) {
    return <Navigate to="/onboarding" replace />;
  }

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900" data-testid="dashboard-layout">
      <Sidebar />
      <main className="lg:pl-72 pt-16 lg:pt-0 min-h-screen">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-8 lg:py-10">
          <SetupChecklist />
          <Outlet />
        </div>
      </main>
    </div>
  );
}
